 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3167ec25cbbf406c3e4770c54eb8045e5c28d4d1","1":"6fc3ac69806bcacc6f10abc7fedf3dd7333280c2","2":"223526a1a0629edaa17bc76f9e188a09eaac8e98","3":"24de3dc64a47051ebc0ffc668641d1d044adafdc","4":"5eed3fe9aa18fdc2a3fba66e67cb5a261c9c414b","5":"29881e0ac3e5784eb2228e964a5b1eae10c0e7ed","6":"6af3e8c128faebbb5d9e81fd2efccca148fa9fb9","7":"b5e6744d","8":"7de890a711a70267e23a73871a458086fa83a688","9":"afe9ac65799d0df07e19d69a461693b8a6850747","10":"c5e0cc1e2ab3c5612da3b68c61739a0e0a3c2cb7","11":"04aa281b9031e2b061d118da463b1f75d99de32a","12":"110f1e2c1bd62d7eb7dcc92921ad47005e6f3ef0","13":"9dce2e8cbca33bd26d95222544c623b96f1324b8","14":"af8b4473f9ff1aa1512d9dde272db8756dbd2e12","15":"c2aad20868020ccc6dc79584802d91cef97051ea","16":"fb5b8a973477d372e486eacf439e9e5b3357df88","20":"component---src-pages-404-tsx","21":"component---src-pages-about-tsx","22":"component---src-pages-ai-tsx","23":"component---src-pages-blog-tsx","24":"component---src-pages-careers-tsx","25":"component---src-pages-contact-tsx","26":"component---src-pages-customers-tsx","27":"component---src-pages-daisee-e-book-tsx","28":"component---src-pages-daisee-white-paper-tsx","29":"component---src-pages-discovery-tsx","30":"component---src-pages-discovery-vds-tsx","31":"component---src-pages-events-dr-claire-ashton-james-index-tsx","32":"component---src-pages-events-g-summit-index-tsx","33":"component---src-pages-events-index-tsx","34":"component---src-pages-index-tsx","35":"component---src-pages-netlify-forms-roi-tsx","36":"component---src-pages-news-index-tsx","37":"component---src-pages-news-management-changes-index-tsx","38":"component---src-pages-privacy-policy-tsx","39":"component---src-pages-product-genesys-landing-index-tsx","40":"component---src-pages-product-genesys-landing-terms-and-conditions-index-tsx","41":"component---src-pages-product-tsx","42":"component---src-pages-solutions-tsx","43":"component---src-pages-start-a-demo-tsx","44":"component---src-pages-thankyou-tsx","45":"component---src-pages-voice-analytics-tsx","46":"component---src-pages-whitepapers-daisee-compensation-effects-tsx","47":"component---src-pages-whitepapers-daisee-dxc-claims-tsx","48":"component---src-pages-whitepapers-daisee-using-ai-whitepaper-tsx","49":"component---src-pages-whitepapers-index-tsx","50":"component---src-templates-customer-story-tsx","51":"component---src-templates-post-tsx","52":"component---src-templates-profile-tsx","53":"component---src-templates-solution-tsx"}[chunkId]||chunkId) + "-" + {"0":"0cc0bb929e842af064bc","1":"e786907e359a2da0bdd3","2":"c8e42cab5624d558b7f1","3":"9a2cdf3b2112d2617fcc","4":"508bfd958713e5d9c997","5":"a875f3ff04ec18b691e9","6":"fdac73703b463e55bd9a","7":"f2e9fd79ae77c1bc8234","8":"6f3bae01170aaa9e28b6","9":"1af4cfdd374cad3b8846","10":"325d55af0d1a52a2b04b","11":"6da3f399772f329e65cf","12":"dfdbe90df02b7b773c47","13":"f8531dd99d198f999de0","14":"bf642e8f292cc47b7797","15":"3bbf79936cc85e29eb82","16":"8f10a3236045c7491c82","20":"be96575312dbf0228f02","21":"042eb4d01cfb5546455b","22":"2cd4af7f1f1cfc173249","23":"866360a992c9cb7f13fa","24":"ad65033b39359f819453","25":"4056f3056a6cce4e15e2","26":"1638ae66414c11953c9a","27":"61b333c37782b1d53211","28":"be47d5052e3eb1162cdf","29":"f5d624ba27d2891ef02f","30":"ec10cff284999792e844","31":"5b2b4407c5694a10b623","32":"2450ba4eb921455bb85d","33":"c2e56ca10b7235a24bed","34":"971e5a5c3877143a97e4","35":"5cc3a664ae505d0d7774","36":"57078d11199aaf362da8","37":"ca171824015e80e10553","38":"1b0f52f61b7b1a293652","39":"4b612fc26df0840f30cb","40":"1f7594e46230975aae2a","41":"a769c710ec7a0a8b3c72","42":"fe412737bef67ab7ec39","43":"4db67735487e8129a402","44":"ba93a305fd5c66aa93ce","45":"efdb23646795726754a7","46":"94f207686dff4bada559","47":"fc50483289b2fade9283","48":"01a0e2748551e8977fa7","49":"c96bf7dc7853359e2063","50":"343ae0984020c36b9639","51":"53f7d234531278285b48","52":"44354708d552b8f452a0","53":"35c3e1161ccf8cf6bf0a","57":"38bca94c95c3c4eee1ef"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
